import { connect as reduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import reducer from './reducer';

const mapStateToProps = ({ authentication, system }) => ({
  authentication,
  system
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onFetchLoginStatus: actions.onFetchLoginStatus,
      onFetchLoginStatuses: actions.onFetchLoginStatuses,
      onLogin: actions.onLogin,
      onLogout: actions.onLogout
    },
    dispatch
  );

const connect = component =>
  reduxConnect(mapStateToProps, mapDispatchToProps)(component);

export default {
  actions,
  connect,
  reducer
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Authentication/index.js